import axios from 'axios'

export const mutations = {
  userRefresh (state, users) {
    state.all = users
    console.log('refresh users')
  },
  userExtend (state, user) {
    console.log('extend user')
    state.all.push(user)
  },
  userEdit (state, userToEdit) {
    console.log('edit user')
    state.editing = state.all.find((user) => {
      return user._id === userToEdit
    })
  },
  userCancelEdit (state) {
    console.log('cancel edit user')
    state.editing = undefined
  },
  userCreate (state) {
    console.log('create user')
    state.editing = { // default value
      'active': true,
      'firstname': '',
      'lastname': '',
      'email': '',
      'workphone': '',
      'address': {
        'street': '',
        'postcode': '',
        'city': ''
      },
      'private': {
        'email': '',
        'phone': ''
      },
      'payment': '0',
      'admin': false,
      'password': 'pass', // TODO, can generate some random and send email to user to reset it as soon as possible
      'customers': [],
      'customerOrig': '',
      'registeredOn': ''
    }
  },
  userUpdateOne (state, updated) {
    console.log('update one user')
    if (state.all.length === 0) {
      state.all.push(updated)
    } else {
      state.all = state.all.map((user) => { // replace the only updated user, others are intact
        return user._id === updated._id ? updated : user
      })
    }
  },
  userToDelete (state, userToDelete) {
    console.log('user to delete')
    state.deleting = state.all.find((user) => { // returns the value of the first element that satisfies the condition
      return user._id === userToDelete._id
    })
  },
  userDeleted (state) {
    state.all = state.all.filter((value) => { // filter out the deleted user
      return value._id !== state.deleting._id
    })
    state.deleting = undefined
  },
  userCancelDelete (state) {
    console.log('cancel delete user')
    state.deleting = undefined
  },
  userError (state) {
    state.error = true
  },
  userCancelError (state) {
    state.error = false
  }
}

export const getters = {
  allUsers: (state) => {
    return state.all
  },
  editingUser: (state) => {
    return state.editing
  },
  alreadyRegistered: (state) => {
    return state.error
  }
}

export default {
  state: {
    all: [],
    editing: undefined,
    deleting: undefined,
    error: false
  },
  getters,
  mutations,
  actions: {
    // ========================================
    fetchUsers: async ({ commit }) => {
      try {
        let users = await axios.get('/api/v1/users')
        commit('userRefresh', users.data)
      } catch (err) {
        commit('userRefresh', [])
      }
    },
    fetchOneUser: async ({ commit }, userId) => {
      try {
        let user = await axios.get('/api/v1/users/' + userId)
        commit('userUpdateOne', user.data[0])
      } catch (err) {
        console.log(err)
      }
    },
    createUser: async ({ commit, state }, { signUpUser, lang }) => {
      let user = state.editing

      user.firstname = signUpUser.firstname
      user.lastname = signUpUser.lastname
      user.email = signUpUser.email
      user.password = signUpUser.password
      user.customerOrig = signUpUser.customerOrig
      user.address = signUpUser.address
      user.private = signUpUser.private
      user.payment = signUpUser.payment
      user.signup = true
      console.log('run createUser', user, signUpUser, lang)

      try {
        let response = await axios.post('/api/v1/users', {user, lang})
        if (response.data.user === undefined) {
          commit('userError')
        } else {
          commit('userExtend', response.data.user) // insert a new user also with its _ID
          commit('userCancelEdit')
        }
      } catch (err) {
        console.log(err)
        commit('userCancelEdit')
      }
    },
    // ========================================
    saveUser: async ({ commit, state }, lang) => {
      let user = state.editing
      console.log('run saveUser', user)

      try {
        if (user._id !== undefined) {
          // Update existing user
          await axios.put('/api/v1/users/' + user._id, {user, lang})
          commit('userUpdateOne', user)
        } else {
          // Add new user
          user.signup = false
          let response = await axios.post('/api/v1/users', {user, lang})
          if (response.data.user === undefined) {
            commit('userError')
          } else {
            commit('userExtend', response.data.user) // insert a new user also with its _ID
          }
        }
        commit('userCancelEdit')

        // after saving the user we need to refresh the customers also
        let customers = await axios.get('/api/v1/customers')
        commit('customerRefresh', customers.data)
      } catch (err) {
        console.log(err)
        commit('userCancelEdit')
      }
    },
    // ========================================
    deleteUsers: async ({ commit, state }) => {
      console.log('run deleteUsers', state.deleting)
      try {
        await axios.delete('/api/v1/users/' + state.deleting._id)

        // after deleting the user we need to refresh the customers also
        let customers = await axios.get('/api/v1/customers')
        commit('customerRefresh', customers.data)

        commit('userDeleted', state.deleting._id)
      } catch (err) {
        console.log(err)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/Users.js